// Paleta de cores para eventos de calendário (projetos/tarefas).
//
// Por que hex e não classes Tailwind dinâmicas:
// as cores são escolhidas por um índice numérico em runtime (projectId % N),
// e o Tailwind não consegue gerar classes a partir de valores dinâmicos
// (purga em build). Por isso mantemos um array de hex — MAS com tons de
// saturação MODERADA e luminosidade MÉDIA, escolhidos para terem bom
// contraste tanto no tema claro quanto no escuro. São usados apenas como
// realce (borda esquerda, ponto, faixa de tag), nunca como fundo de texto
// extenso, então a legibilidade fica garantida nos dois temas.
//
// Quando precisar apenas de uma cor semântica fixa (ex.: tarefas agendadas),
// prefira os tokens do design system (text-brand, bg-info, etc.).

export const EVENT_COLORS: readonly string[] = [
  '#3b82f6', // azul
  '#10b981', // verde-esmeralda
  '#f59e0b', // âmbar
  '#ef4444', // vermelho
  '#8b5cf6', // violeta
  '#06b6d4', // ciano
  '#ec4899', // rosa
  '#f97316', // laranja
  '#14b8a6', // teal
  '#6366f1', // índigo
] as const;

/** Retorna uma cor de evento estável a partir de um id numérico. */
export function getEventColor(id: number): string {
  const index = Math.abs(id) % EVENT_COLORS.length;
  return EVENT_COLORS[index];
}
